import styled from 'styled-components';

export const TextLinkStyle = styled.a`
  text-decoration: underline;
  color: ${({ theme }) => theme.primary_300};
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`;
